import "./app.scss";
import Header from "./components/Header/Header";
import { userInfo } from "./config/requests";
import { useQuery } from "@tanstack/react-query";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { notification } from "antd";
import React, { lazy, Suspense, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAccount } from "wagmi";

const IntroDescription = lazy(
  () => import("./components/IntroDescription/IntroDescription")
);
const Slider = lazy(() =>
  import("./components/slider").then((module) => ({ default: module.Slider }))
);
const Contacts = lazy(() =>
  import("./components/contacts").then((module) => ({
    default: module.Contacts,
  }))
);

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isConnected: isEthConnected } = useAccount();
  const [tonConnectUI] = useTonConnectUI();

  const { data: userData, refetch: updateProfile } = useQuery({
    queryKey: ["user-info"],
    queryFn: async () => {
      const response = await userInfo();
      if (response.status === 401) return null;
      const json = await response.json();
      return json["user"];
    },
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (!isEthConnected && tonConnectUI.connected) {
      tonConnectUI.connectionRestored.then(() => {
        console.log("TON Connection restored");
      });
    }
  }, [isEthConnected, tonConnectUI]);

  useEffect(() => {
    if (new URLSearchParams(location.search).get("success") === "true") {
      notification.success({
        message: "Successful purchase",
        description:
          "Please wait a couple of minutes and your purchase will be displayed",
        duration: 10,
      });
      navigate("/", { replace: true });
    }
  }, [location.search, navigate]);

  const username = useMemo(() => userData?.username?.split("@")[0], [userData]);

  return (
    <>
      <Header username={username} updateProfile={updateProfile} />
      <main>
        <Suspense fallback={null}>
          <IntroDescription />
          <Slider username={username} updateProfile={updateProfile} />
          <Contacts />
        </Suspense>
      </main>
    </>
  );
}
